import { addListener } from "../utils/utils"

export function setupSlider(thumb: Element, track: Element, setter: (pct: number) => void) {

    let cleanup = () => { }
    let captured = false

    const down = addListener(thumb, "pointerdown", () => {

        if (captured) {
            return
        }

        const doc = document

        const { left, width } = track.getBoundingClientRect()

        const move = addListener(doc, "pointermove", (e: PointerEvent) => setFromPosition(e.clientX, width, left))

        const up = addListener(doc, "pointerup", (e: PointerEvent) => {
            cleanup()
        })

        captured = true

        cleanup = () => {
            cleanup = () => { }
            captured = false
            move()
            up()
        }

    })

    const click = addListener(track, "click", (e: PointerEvent) => {
        const { left, width } = track.getBoundingClientRect()
        setFromPosition(e.clientX, width, left)
    })

    const setFromPosition = (x: number, width: number, left: number) => {
        if (width) {
            const pct = Math.min(1, Math.max(0, (x - left) / width))
            setter(pct)
        }
    }

    return () => {
        down()
        click()
        cleanup()
    }

}
